export default "__VITE_ASSET__c0bba848__"